import { DocumentsContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const useDocumentContextlessPolicies = () => {
  const { loading, data } = useQuery(DocumentsContextlessPoliciesDocument, {})

  return {
    loading: loading,
    policies: data?.documents?._policies,
  }
}

export default useDocumentContextlessPolicies
